import React, { useEffect, useState } from "react";
import BarChart from "../ui/BarChart";
import api from "../../api/axios";
import ModelSelect from "../ui/ModelSelect";

const CoupeChart = () => {
  const [selectedOption, setSelectedOption] = useState("Dashboard");
  const [models, setModels] = useState([]);
  const [error, setError] = useState(null);
  const [barChartData, setBarChartData] = useState({
    labels: ["Coupe"],
    datasets: [
      {
        label: "Entrée",
        data: [0],
        backgroundColor: "rgba(255,99,132,0.2)",
        borderColor: "rgba(255,99,132,1)",
        borderWidth: 1,
      },
      {
        label: "Encours",
        data: [0],
        backgroundColor: "rgba(54,162,235,0.2)",
        borderColor: "rgba(54,162,235,1)",
        borderWidth: 1,
      },
      {
        label: "Sortie",
        data: [0],
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
        borderWidth: 1,
      },
    ],
  });

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    const selectedModelData = models.find(
      (model) => model.id === parseInt(event.target.value)
    );

    handleModal(selectedModelData);
  };

  useEffect(() => {
    const fetchModels = async () => {
      try {
        const response = await api.get("/models");
        setModels(response.data);
      } catch (error) {
        console.error("Error fetching models:", error);
      }
    };

    fetchModels();
  }, []);

  const barChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Production Stage",
          font: {
            size: 14,
            weight: '600'
          }
        },
      },
      y: {
        title: {
          display: true,
          text: "Quantity",
          font: {
            size: 14,
            weight: '600'
          }
        },
      },
    },
  };

  const handleModal = async (model) => {
    setError(null);
    try {
      const response = await api.get(`/coupe_production/${model.id}`);
      const coupeProductionValue = response.data;
      const entreValue = model.quantite_demandee;
      const encoursValue = parseFloat(entreValue) - parseFloat(coupeProductionValue);
      setBarChartData({
        labels: ["Coupe"],
        datasets: [
          {
            label: "Entrée",
            data: [entreValue],
            backgroundColor: "rgba(54,162,235,0.8)",
            borderColor: "rgba(54,162,235,1)",
            borderWidth: 1,
          },
          {
            label: "Encours",
            data: [encoursValue],
            backgroundColor: "rgba(255,99,132,0.8)",
            borderColor: "rgba(255,99,132,1)",
            borderWidth: 1,
          },
          {
            label: "Sortie",
            data: [coupeProductionValue],
            backgroundColor: "rgba(75,192,192,0.8)",
            borderColor: "rgba(75,192,192,1)",
            borderWidth: 1,
          },
        ],
      });
    } catch (error) {
      setError(error.response?.data?.message || "An error occurred");
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Analyse des Étapes de Production </h2>
          <p className="text-gray-600 mt-1">Visualisation des quantités d'entrée, en cours et de sortie</p>
        </div>
        <div className="w-full sm:w-64">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Sélectionner un Modèle
          </label>
          <ModelSelect value={selectedOption} onChange={handleSelectChange} models={models} />
        </div>
      </div>

      {error ? (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg flex items-center">
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
          </svg>
          {error}
        </div>
      ) : (
        <BarChart 
          data={barChartData} 
          options={barChartOptions}
          title="Production de Coupe et Encours"
          subtitle="Suivez les étapes de production : Entrée, En Cours, et Sortie"
        />
      )}
    </div>
  );
};

export default CoupeChart;
